namespace TabAurous {
    export interface OwnStockDetailedRequest extends Serenity.ServiceRequest {
        Items?: TabAurous.Reports.StockBifurcationRow[];
        ProductIds?: number[];
    }
}
